(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global["@readcube/viewer-frame"] = factory());
})(this, (function () { 'use strict';

  var e=[],t=[];function n(n,r){if(n&&"undefined"!=typeof document){var a,s=!0===r.prepend?"prepend":"append",d=!0===r.singleTag,i="string"==typeof r.container?document.querySelector(r.container):document.getElementsByTagName("head")[0];if(d){var u=e.indexOf(i);-1===u&&(u=e.push(i)-1,t[u]={}),a=t[u]&&t[u][s]?t[u][s]:t[u][s]=c();}else a=c();65279===n.charCodeAt(0)&&(n=n.substring(1)),a.styleSheet?a.styleSheet.cssText+=n:a.appendChild(document.createTextNode(n));}function c(){var e=document.createElement("style");if(e.setAttribute("type","text/css"),r.attributes)for(var t=Object.keys(r.attributes),n=0;n<t.length;n++)e.setAttribute(t[n],r.attributes[t[n]]);var a="prepend"===s?"afterbegin":"beforeend";return i.insertAdjacentElement(a,e),e}}

  var css = ":root {\n  --loader-color: rgba(40, 77, 97, 1);\n}\n\n.viewer-loader {\n  display: inline-block;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 80px;\n  height: 80px;\n  transform: translate(-50%, -50%);\n}\n.viewer-loader:after {\n  content: \" \";\n  display: block;\n  width: 64px;\n  height: 64px;\n  margin: 8px;\n  border-radius: 50%;\n  border: 6px solid var(--loader-color);\n  border-color: var(--loader-color) transparent var(--loader-color) transparent;\n  animation: viewer-loader 1.2s linear infinite;\n}\n\n@keyframes viewer-loader {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.viewer-frame {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  background-color: transparent;\n  border: 0px none transparent;\n  padding: 0px;\n  overflow: hidden;\n  visibility: hidden;\n  pointer-events: none;\n  z-index: -1;\n}\n.viewer-frame.visible {\n  visibility: visible;\n  pointer-events: auto;\n  z-index: 0;\n}\n\n.screen {\n  display: none;\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  z-index: 1;\n  cursor: not-allowed;\n  background-color: white;\n  animation: fadeInFromNone 0.3s;\n}\n.screen.visible {\n  display: block;\n}";
  n(css,{});

  var version = "2.0.0";

  function writeImageToClipbard (blob) {
    return navigator?.permissions?.query({ name: 'clipboard-write' })
      .then(result => {
        if (result.state === 'granted') {
          const data = [new window.ClipboardItem({ [blob.type]: blob })];
          return navigator.clipboard.write(data)
        }
      })
  }

  function downloadUrl (url, fileName = 'snippet.png') {
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.click();
  }

  console.log(`### @readcube/viewer-frame v${version}`);

  // const VIEWER_VERSION = dependencies['@readcube/viewer-core'].replace(/^\D+/, '')
  const VIEWER_VERSION = '4.4.1';
  const VIEWER_ORIGIN = 'https://pkg.readcube.com/@readcube/viewer-core';

  function injectJS (frame, src) {
    return new Promise(resolve => {
      setTimeout(() => {
        const script = document.createElement('script');
        script.src = src;
        script.onload = resolve;
        script.type = 'text/javascript';
        frame.contentWindow.document.head.appendChild(script);
      }, 0);
    })
  }

  async function create ({ container, pdf }) {
    if (window.getComputedStyle(container).position === 'static') {
      container.style.position = 'relative';
    }

    const frame = document.createElement('iframe');
    frame.classList.add('viewer-frame');
    frame.setAttribute('seamless', '');
    frame.setAttribute('allowTransparency', 'true');

    const loader = document.createElement('div');
    loader.classList.add('viewer-loader');

    const screen = document.createElement('div');
    screen.classList.add('screen');

    container.appendChild(loader);
    container.appendChild(frame);
    container.appendChild(screen);

    return injectJS(frame, `${VIEWER_ORIGIN}@${VIEWER_VERSION}/index.js`)
      .then(init)
      .catch(err => console.error(err))

    function removeElements () {
      if (frame && frame.parentNode) {
        frame.parentNode.removeChild(frame);
      }
      if (screen && screen.parentNode) {
        screen.parentNode.removeChild(screen);
      }
      if (loader && loader.parentNode) {
        loader.parentNode.removeChild(loader);
      }
    }

    function init () {
      if (!frame.contentWindow) {
        throw new Error('@readcube/viewer-frame: frame.contentWindow is null')
      }

      const viewer = frame.contentWindow['@readcube/viewer-core'].default;
      const div = document.createElement('div');
      frame.contentWindow.document.body.appendChild(div);

      return viewer.init({ container: div, pdf }).then(() => {
        if (loader && loader.parentNode) {
          loader.parentNode.removeChild(loader);
        }

        viewer.theme = 'dark';
        frame.classList.add('visible');

        const instance = {
          destroy,
          on,
          off,
          get excerpt () { return viewer.excerpt },
          get disabled () { return screen.classList.contains('visible') },
          set disabled (val) { return screen.classList.toggle('visible', !!val) }
        };

        instance.on('capture-start', () => {
          instance.disabled = true;
        });
        instance.on('captured-image', async (e, data) => {
          console.log('captured image:', data);
          console.log(`image type: ${data.imageData.type}`);
          console.log(`image size: ${data.imageData.size / 1e3} KB`);
          try {
            await writeImageToClipbard(data.imageData);
            console.log('Copied to clipboard');
          } catch (err) {
            console.error(err);
          } finally {
            instance.disabled = false;
            downloadUrl(URL.createObjectURL(data.imageData));
          }
        });

        return instance
      })

      function destroy () {
        destroyViewer();
        removeElements();
      }

      function destroyViewer () {
        if (viewer) viewer.destroy();
      }

      function on (evtName, handler) {
        return viewer.on(evtName, handler)
      }

      function off (evtName, handler) {
        return viewer.off(evtName, handler)
      }
    }
  }

  var index = { create };

  return index;

}));
